// extracted by mini-css-extract-plugin
module.exports = {"container":"TrailStats_container__clJxp","lg":"TrailStats_lg__cI_Xq","adminStats":"TrailStats_adminStats__aotKd","editIcon":"TrailStats_editIcon__gVt1g"};